/* Base Layout
Author: Maxwell Levene @maxlevene920- Ellmarr
Date: 04/30/2025
Description: Service module for managing user operations. Handles user authentication,
profile management, and role-based access control.
*/

import { calculateUserCO2Offset } from './users/userUtils';
import { userCrudService } from './users/userCrudService';
import { userStatsService } from './users/userStatsService';
import { userRidesService } from './users/userRidesService';
import type { UserDetails, UserStatistics, UserCounts, BikeRide } from './users/types';

// Re-export all interfaces and types
export type { UserDetails, UserStatistics, UserCounts, BikeRide };

// Re-export utility functions
export { calculateUserCO2Offset };

// Create a comprehensive userService by combining all the modular services
export const userService = {
  // User CRUD operations
  getUsers: userCrudService.getUsers,
  getUser: userCrudService.getUser,
  createUser: userCrudService.createUser,
  updateUser: userCrudService.updateUser,
  deleteUser: userCrudService.deleteUser,
  
  // User statistics
  getUserStatistics: userStatsService.getUserStatistics,
  countUsersByRole: userStatsService.countUsersByRole,
  
  // User rides
  getUserRides: userRidesService.getUserRides,
};
